export default __webpack_public_path__ + "packet-broker.443f32ab8be6b3c3732c158925ff0527.svg";